export const assertSearchProductAncestor = (
  value: unknown,
  ancestorProviderName: string,
  consumerName: string
): void => {
  if (typeof value !== 'function') {
    throw new Error(`${consumerName} must be rendered inside ${ancestorProviderName}`);
  }
};

export const shouldSkipRefineReset = (
  effectiveRefineSearch: string,
  skipEmptyRefineReset: boolean
): boolean => !effectiveRefineSearch && skipEmptyRefineReset;

export const isCancelledQueryError = (error: unknown): boolean =>
  (error as Error)?.name === 'CancelledError';

export const getFavoritesErrorMessage = (error: unknown): string => {
  const err = error as { response?: { data?: { message?: string } }; message?: string };
  return (
    err?.response?.data?.message ||
    err?.message ||
    'Failed to add item(s) to Shopping List. Please try again.'
  );
};
